<template>
    <div class="">
        <h5 class="h5">Registrants</h5>
        <div id="reg-heading" @click="showList = !showList" class="border rounded p-2 d-flex align-content-center" :expanded="showList && registrants.length > 0" style="background-color: rgba(0,0,0,0.03) !important;">
            <div class="flex-grow-1">Currently enrolled:  {{ registrants.length }}</div>
            <div>
                <i class="fas fa-chevron-up me-2" v-if="!showList"></i>
                <i class="fas fa-chevron-down me-2" v-if="showList"></i>
            </div>
        </div>
        <transition name="slide-down">
            <ul class="list-group"  v-show="showList" style="border-top-left-radius: 0;border-top-right-radius: 0;">
                <li class="list-group-item" v-for="reg in registrants">{{ reg.LastName }}, {{ reg.FirstName }}</li>
            </ul>
        </transition>
    </div>
</template>

<script>
export default {
    data() {
        return {
            showList: false
        };
    },
    
    props: {
        registrants: {
            type: Array,
            required: true,
        }
    },
    
    mounted: function() {
        // console.log(this.registrants);
    }
}
</script>

<style scoped>
    .slide-down-enter-active {
        animation: wait-and-fade-in .5s;
    }
    
    .slide-down-leave-active {
        animation: fade-out .5s;
    }

    @keyframes wait-and-fade-in {
        0% {
            opacity: 0;
        }
        
        66% {
            opacity: 0;
        }
        
        100% {
            opacity: 1;
        }
    }
    
    @keyframes fade-out {
        0% {
            opacity: 1;
        }
        
        50% {
            opacity: 0;
        }
        
        100% {
            opacity: 0;
        }
    }
    
    #reg-heading[expanded] {
        border-bottom-right-radius: 0 !important;
        border-bottom-left-radius: 0 !important;
    }
</style>
